export type State = {
  isSubmitting: boolean;
  error: { message: string } | null;
};

export const defaultState: State = {
  isSubmitting: false,
  error: null,
};
